import React,{useState} from "react";
const Checkbox = ( {onchange,name,value,type,status,title,card}) =>{
    
 const [active , setActive] = useState({status:status});
  return(<>
  
   <label className={card==="checkbox"?"checkbox-outer  ":card==="radio"?"radio-outer":card==="card"?"boxCard-outer":""}>
                                        {card==="checkbox"||card==="radio"?
                                        <div style={{"marginLeft": "30px","marginTop": "-10px" }} >{typeof value === 'boolean'?title:value}</div>:typeof value === 'boolean'?title:value}   
                                       
                                                <input type={type} title={title}
                                                 className="input-textbox" checked= {active.status} value={value} name={name}  
     onChange={e=>{
        setActive({...active,status:!active.status});
       
        
       }
       
    }
    onChangeCapture={onchange }
    />
                                                   <span class={card==="checkbox"?"square":card==="radio"?"circle":card==="card"?"boxCardBorder":""}></span>
                                          </label>
   
  </>)  
}
export default Checkbox;


